import React from 'react'
import { I18n } from 'react-redux-i18n'
import { toast } from 'react-toastify'

import './styles.scss'
import { store } from '../../../redux'
import { getTone } from 'utils/statics'

/**
 * Muestra una notificación de lado derecho de la pantalla
 * @param {String} title
 * @param {String} message
 * @param {String} type
 */
export const displayNotification = ({ title, message = '', type = 'text', channel }) => {
  const { currentNotifications } = store.getState()
  const { withPreview, sound: defaultSound, duration, channels: channelsSound } = currentNotifications
  const options = {
    position: 'top-right',
    time: duration,
    text: {
      icon: null,
      title: title,
      message: withPreview ? message : I18n.t('notification_received_message'),
    },
    note: {
      icon: null,
      title: title,
      message: message,
    },
    image: {
      icon: 'editor-image.svg',
      title: title,
      message: I18n.t('notification_received_image'),
    },
    video: {
      icon: 'editor-video.svg',
      title: title,
      message: I18n.t('notification_received_video'),
    },
    location: {
      icon: 'editor-application.svg',
      title: title,
      message: I18n.t('notification_received_location'),
    },
    audio: {
      icon: 'editor-video.svg',
      title: title,
      message: I18n.t('notification_received_audio'),
    },
    pdf: {
      icon: 'editor-application.svg',
      title: title,
      message: I18n.t('notification_received_file'),
    },
    file: {
      icon: 'editor-application.svg',
      title: title,
      message: I18n.t('notification_received_file'),
    },
  }
  playSound({ channel, channelsSound, defaultSound })
  toast(
    <Notification
      title={options[type].title}
      message={options[type].message}
      icon={options[type].icon}
      withPreview={withPreview}
    />, {
      position: options.position,
      autoClose: options.time,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      className: 'nixi1-notification',
      bodyClassName: 'nixi1-notification-body',
    }
  )
}

const Notification = ({ title, message, icon, withPreview }) => {
  return (
    <div className='wrapper-message'>
      <div className='icon-message-wrapper'>
        <img
          className='icon-message'
          src='https://assets.nixi1.dkv.es/dashboard_front/images/nixi1-notification-logo-v2.png'
          alt='nixi1'
        />
      </div>
      <div className='text-message'>
        {withPreview ? <p className='title-message'>{title}</p> : null}
        <p className={`body-message ${!withPreview && 'center-message'}`}>
          {icon ? <img src={`img/icons/${icon}`} alt={icon} /> : null} {message}
        </p>
      </div>
    </div>
  )
}

const playSound = ({ channel, channelsSound = [], defaultSound }) => {
  try {
    // Caso 1: sonido por defecto
    let sound = defaultSound

    if (channelsSound?.length) {
      const isChatmail = channel.hub === 'chatmail'

      // Caso 2: Buscar sonido de canal específico por key y token
      const specificChannelSound = channelsSound.find(it => {
        if (it.channelToken !== channel.channelToken) return false

        if (isChatmail && it.hub === channel.hub) return true
        if (it.key === channel.key) return true

        return false
      })


      if (specificChannelSound) {
        sound = specificChannelSound.sound
      } else {
        // Caso 3: Buscar sonido de canal general por key o hub (ChatMail)
        const generalChannelSound = channelsSound.find(it => {
          if (it.channelToken || it.channelId) return false

          if (isChatmail && it.hub === channel.hub) return true
          if (it.key === channel.key) return true

          return false
        })

        if (generalChannelSound) {
          sound = generalChannelSound.sound
        }
      }
    }

    if (sound && sound !== 'none') {
      const audio = new Audio(getTone(`/${sound}.mp3`))
      audio.play()
    }

    return true
  } catch(error) {
    return false
  }
}
